import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Router } from '@angular/router';
import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';

@Component({
    selector: 'disclaimer-box',
    templateUrl: './disclaimerbox.component.html',
    styleUrls: ['./disclaimerbox.component.scss']
})
export class DisclaimerBoxComponent {
    @Input() public doesNotHasEngoughBalance: boolean;
    @Input() public hasEnoughBalance: boolean;
    @Input() public debitBalance: boolean;
    @Input() public finedToday: boolean;

    public constructor(
        private router: Router,
        private store: Store<AppState>,
    ) {}

    public redirectDeposit() {
        this.router.navigate(['/home/transferencia']);

        this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, {
            'Product Area Origin': 'Bolsa',
            'Element': 'Botão transferir recursos',
            'Time Responsavel': 'Roebling',
            'Step': 'Garantias',
            'Scenario': 'Saldo insuficiente',
        });
    }

    public sendDisclaimerTracking(scenario: string) {
        if(scenario == 'enough-balance') {
            this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, {
              'Product Area Origin': 'Bolsa',
              'Element': 'Link entenda',
              'Time Responsavel': 'Roebling',
              'Step': 'Garantias',
              'Scenario': 'Garantia em uso',
              'Label': 'Nome do input'
            });
        }

        if(scenario == 'not-enough-balance') {
            this.sendTracking(ActionEventsEnum.ELEMENT_CLICKED, {
                'Product Area Origin': 'Bolsa',
                'Element': 'Link entenda',
                'Time Responsavel': 'Roebling',
                'Step': 'Garantias',
                'Scenario': 'Saldo insuficiente',
                'Label': 'Nome do input'
            });
        }
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }
}
